
class ResponseService {
    async get(to){
        try{
            const response = await fetch(to,{
                method:'GET',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    // 'Access-Control-Allow-Origin':  'http://localhost:3000',
                    //  'Access-Control-Allow-Methods': 'POST',
                    //  'Access-Control-Allow-Headers': 'Content-Type, Authorization'
                },
            })
            const result = await response.json()
            console.log(result)
            return result
        } catch(err){
            console.log(err)
            return null
        }
    }

    async post(to,data={}){
        try{
            const response = await fetch(to,{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    // 'Access-Control-Allow-Origin':  'http://localhost:3000',
                    //  'Access-Control-Allow-Methods': 'POST',
                    //  'Access-Control-Allow-Headers': 'Content-Type, Authorization'
                },
                body: JSON.stringify(data)
            })
            const result = await response.json()
            console.log(result)
            return result
        } catch(err){
            console.log(err)
            return null
        }
    }

    async put(to,data={}){
        try{
            const response = await fetch(to,{
                method:'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    // 'Access-Control-Allow-Origin':  'http://localhost:3000',
                    //  'Access-Control-Allow-Methods': 'POST',
                    //  'Access-Control-Allow-Headers': 'Content-Type, Authorization'
                },
                body: JSON.stringify(data)
            })
            const result = await response.json()
            console.log(result)
            return result
        } catch(err){
            console.log(err)
            return null
        }
    }
    async delete(to){
        try{
            const response = await fetch(to,{
                method:'DELETE',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    // 'Access-Control-Allow-Origin':  'http://localhost:3000',
                    //  'Access-Control-Allow-Methods': 'POST',
                    //  'Access-Control-Allow-Headers': 'Content-Type, Authorization'
                },
            })
            const result = await response.json()
            console.log(result)
            return result
        } catch(err){
            console.log(err)
            return null
        }
    }
}

const responseService = new ResponseService()

export default responseService